export const initComponents = () => {
  // URL is in format /components/:component/:sessionId?signature=<signature>&timestamp=<timestamp>
  // extract information from current URL and store
  const url = new URL(window.location.href);
  const re = /\/components\/([^/]+)\/([^/]+)(.*)/;
  const matches = url.pathname.match(re);
  if (!matches) {
    console.error('Invalid URL');
    return;
  }
  const component = matches[1];
  const sessionId = matches[2];
  const searchParams = new URLSearchParams(url.search);

  (window as any).__componentsInitialData = {
    component,
    sessionId,
    searchParams,
  };
  window.history.replaceState({}, '', '/');
  const componentsCallback: ComponentsCallback = (
    type: string,
    payload: any
  ) => {
    try {
      if (window.parent !== window) {
        window.parent.postMessage(
          JSON.stringify({
            timestamp: Date.now(),
            type,
            payload,
          }),
          '*'
        );
      } else {
        console.log('componentsCallback', type, payload);
      }
    } catch (e) {
      console.error('Failed to post message to parent', e);
    }
  };
  (window as any).__componentsCallback = componentsCallback;

  componentsCallback('init', null);

  const pmsIntegration: PMSIntegration = {
    handleSave: async () => {
      return;
    },
    waitAndClose: (work?: () => Promise<void>) => {
      return async () => {
        if (work) await work();
        Promise.all(pmsIntegration.pending).then(() => {
          componentsCallback('close', null);
        });
      };
    },
    pending: [],
    saveSummary: async (text) => {
      componentsCallback('saveSummary', text);
    },
  };

  (window as any).pmsIntegration = pmsIntegration;
};

export type PMSIntegration = {
  handleSave: (force?: boolean) => Promise<void>;
  waitAndClose: (work?: () => Promise<void>) => () => void;
  pending: Promise<void>[]; // list of pending promises
  saveSummary: (text: string) => Promise<void>;
};

export type ComponentsCallback = (type: string, payload: any) => void;
